import { Typography } from '@mui/material';
import styled from 'styled-components';

import { TTypographyVariantKey } from '@/console/features/pipelines/components/pipeline-trigger-type/pipeline-trigger-type.types';

export const TypographyWithIcon = styled(Typography)`
  && {
    display: inline-flex;
    align-items: center;

    svg {
      color: inherit;
      margin: ${({ variant, theme }) => {
        const typographyVariant = (variant as TTypographyVariantKey) ?? 'p8';
        const style = theme.typography[typographyVariant];
        return `calc(${style.fontSize} - 0.5rem)`;
      }};
    }
  }
`;
